import React, { Fragment } from "react";
import header from "../../../Assets/Styles/header.module.css";
import logo from "../../../Assets/Images/logo/global-it-master-logo-header.jpg";
import ServicesMegaMenu from "./ServicesMegaMenu";
import MobileMenu from "./MobileMenu";
import SubHeader from "./SubHeader";
import auth from "../../../FirebaseInit/FirebaseInit";
import { useAuthState } from "react-firebase-hooks/auth";
import Loading from "../Loading/Loading";
import { toast } from "react-toastify";
import { Link, NavLink } from "react-router-dom";
const Header = () => {
  const [user, loading, error] = useAuthState(auth);

  if (loading) {
    return <Loading />;
  }
  if (error) {
    toast.error(error.message);
  }

  return (
    <Fragment>
      <SubHeader />
      <header className="hidden max-lg:block border-b border-[#f5e4e4]">
        <div className="  max-lg:max-w-[1020px] max-xl:max-w-[1200px] mx-auto font-roboto flex justify-between items-center">
          <div>
            <NavLink to="/">
              <img
                className=" max-h-[50px] max-xl:max-h-[50px]"
                src={logo}
                alt="IT Ghar Logo"
              />
            </NavLink>
          </div>
          <nav className="flex relative justify-center items-center">
            <NavLink
              to="/"
              className={`mr-6 block ${header.homeItems} ${header.navMenuItems}   leading-[113px] relative text-[#101130] text-base font-bold font-roboto`}
            >
              Home
            </NavLink>
            <span
              className={`mr-6 block cursor-pointer ${header.servicesMenu}  leading-[113px]  flex items-center justify-center text-[#101130] text-base font-bold font-roboto`}
            >
              Services
              <i className="fa-solid ml-1 fa-chevron-down text-xs text-[#101130] font-semibold"></i>
              {/* mega menu items */}
              <div className={`absolute top-[108px] z-10 ${header.megaMenu} `}>
                <ServicesMegaMenu />
              </div>
            </span>
            <NavLink
              to="/course"
              className={`mr-6 block leading-[113px]  relative   text-primary ${header.navMenuItems} text-base font-bold font-roboto`}
            >
              Course
            </NavLink>
            {/* 
            <NavLink
              to="/shop"
              className={`mr-6 leading-[113px] relative text-[#101130] ${header.navMenuItems} text-base font-bold font-roboto`}
            >
              Shop
            </NavLink> */}
            <NavLink
              to="/portfolio"
              className={`mr-6 block leading-[113px]  relative    text-[#101130] text-base ${header.navMenuItems} font-bold font-roboto ${header.navMenuItems}`}
            >
              Portfolio
            </NavLink>
            <NavLink
              to="/blog"
              className={`mr-6 block leading-[113px]  relative   text-[#101130] ${header.navMenuItems} text-base font-bold font-roboto`}
            >
              Blog
            </NavLink>

            <span
              className={` flex leading-[113px] relative  ${header.HeaderPageItems} ${header.navMenuItems} block items-center justify-center text-[#101130] text-base font-bold font-roboto`}
            >
              Company
              <i className="fa-solid  ml-1 fa-chevron-down text-xs text-[#101130] font-semibold"></i>
              <div
                className={`z-10 absolute top-[113px] ${header.pageItemDropdown}   bg-[#fff]  rounded-b  shadow w-44 `}
              >
                <ul
                  className="py-2 text-sm text-gray-700 dark:text-gray-200"
                  aria-labelledby="dropdownDelayButton"
                >
                  <li>
                    <NavLink
                      to="/contact"
                      className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                    >
                      Contact Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/about"
                      className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                    >
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/faqs"
                      className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                    >
                      FAQs
                    </NavLink>
                  </li>
                </ul>
              </div>
            </span>
          </nav>
          <div>
            {user ? (
              <Link to="/dashboard">
                {" "}
                <button className="custom_button uppercase flex justify-center items-center">
                  Profile
                  <i className="fa-solid ml-2 fa-user"></i>
                </button>
              </Link>
            ) : (
              <Link to="/login">
                <button className="custom_button flex justify-center items-center">
                  Login
                  <i className="fa-solid ml-2 fa-right-to-bracket"></i>
                </button>
              </Link>
            )}
          </div>
        </div>
      </header>
      {/* Mobile Menu  */}
      <header className=" block max-lg:hidden">
        <MobileMenu />
      </header>
    </Fragment>
  );
};

export default Header;
